import React, { Component } from 'react';
import { withStyles, withTheme } from '@material-ui/core/styles';
import CropCanvas from './CropCanvas';
import { withData } from '../utility/DataContext';


function clamp(num, min, max) {
  return num <= min ? min : num >= max ? max : num;
}

const styles = theme => ({
  overlay: {
    position: 'relative',
  }
});

const Knot = ({width, color, style}) => {
  return  (
    <svg width={width} height={width} style={style}>
      <circle cx={width/2} cy={width/2} r={width/2} fill={color} />
    </svg>
  );
};


class CropOverlay extends Component {
  constructor(props) {
    super(props);
    // imageSize imagePos
    this.state = {
      edit: false,
      pos: {x: 0, y: 0},
      size: {width: 0, height: 0},
      downPos: {x: 0, y: 0},
      edgeIndex: {x: -1, y: -1},
      anchorPoints: {x: [], y: []},
      validate: {
        size: true,
        aspect: true,
      }
    };
    this.overlay = null;
    this.cursorMap = [
      ['nw-resize', 'w-resize', 'sw-resize'],
      ['n-resize', 'move', 's-resize'],
      ['ne-resize', 'e-resize', 'se-resize']
    ];
    this.isTouch = this.props.data.isMobile;
    this.event = {
      down: this.isTouch ? 'touchstart' : 'mousedown',
      move: this.isTouch ? 'touchmove' : 'mousemove',
      up: this.isTouch ? 'touchend' : 'mouseup',
    }
  }

  componentDidMount() {
    const shortLength = Math.min(this.props.imageSize.width, this.props.imageSize.height) * 0.8;
    this.setState({
      size: {
        width: shortLength,
        height: shortLength
      },
      pos: {
        x: (this.props.imageSize.width - shortLength)/2,
        y: (this.props.imageSize.height - shortLength)/2,
      }
    }, this.updateCropArea)
    document.addEventListener(this.event.move, this.onMove, {passive: false});
    document.addEventListener(this.event.down, this.onDown);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.edit && !prevState.edit) {
      document.addEventListener(this.event.up, this.onUp);
    } else if (!this.state.edit && prevState.edit) {
      document.removeEventListener(this.event.up, this.onUp);
    }

    if (this.state.pos !== prevState.pos || this.state.size !== prevState.size){
      this.setCropArea();
    }
  }

  componentWillUnmount() {
    document.removeEventListener(this.event.move, this.onMove);
    document.removeEventListener(this.event.down, this.onDown);
  }

  detectEdge = (value, isX) => {
    const threshold = this.isTouch ? 25 : 8;
    const length = isX ? this.state.size.width : this.state.size.height;
    if (value < -threshold || value > length + threshold){
      return -1;
    }else if (value < threshold){
      return 0;
    }else if (value > length - threshold){
      return 2;
    }
    return 1;
  }

  detectCursor = (x, y) => {
    const rect = this.overlay.getBoundingClientRect();
    const relX = x - rect.left - window.scrollX;
    const relY = y - rect.top - window.scrollY;
    const mx = this.detectEdge(relX, true);
    const my = this.detectEdge(relY, false);
    this.setState({
      edgeIndex: {x: mx, y: my},
    })
    var cursor;
    if (Math.min(mx, my) === -1){
      cursor = 'auto';
    }else{
      cursor = this.cursorMap[mx][my]
    }
    this.props.setCursor(cursor);
    return cursor;
  }

  onUp = e => {
    this.setState({
      edit: false
    });
    if (!this.isTouch) e.preventDefault();
  }

  onMove = e => {
    const pageX = this.isTouch ? e.targetTouches[0].pageX : e.pageX
    const pageY = this.isTouch ? e.targetTouches[0].pageY : e.pageY
    if (this.state.edit){
      var x, y;
      if (this.props.getCursor() === 'move'){
        x = pageX - this.state.downPos.x;
        y = pageY - this.state.downPos.y;
        x = clamp(x, 0, this.props.imageSize.width - this.overlay.offsetWidth);
        y = clamp(y, 0, this.props.imageSize.height - this.overlay.offsetHeight);
        this.setState({pos: {x: x, y: y}}, this.updateCropArea);
      }else{
        const rect = this.overlay.getBoundingClientRect();
        x = pageX - rect.left - window.scrollX + this.state.pos.x;
        y = pageY - rect.top - window.scrollY + this.state.pos.y;
        x = clamp(x, 0, this.props.imageSize.width);
        y = clamp(y, 0, this.props.imageSize.height);
        var xp = this.state.anchorPoints.x.slice();
        var yp = this.state.anchorPoints.y.slice();
        if (xp.length < 2){
          xp.push(x);
        }
        if (yp.length < 2){
          yp.push(y);
        }
        var x0 = Math.min(...xp);
        var x1 = Math.max(...xp);
        var y0 = Math.min(...yp);
        var y1 = Math.max(...yp);
        this.setState({
          pos: {
            x: x0,
            y: y0
          },
          size: {
            width: x1 - x0,
            height: y1 - y0
          }
        }, this.updateCropArea);
      }
    }else{
      this.detectCursor(pageX, pageY);
    }
    if (!(this.isTouch && !this.state.edit)){
      e.preventDefault();
    }
  }

  onDown = e => {
    const pageX = this.isTouch ? e.targetTouches[0].pageX : e.pageX
    const pageY = this.isTouch ? e.targetTouches[0].pageY : e.pageY
    const cursor = this.detectCursor(pageX, pageY);
    if (cursor === 'move'){
      this.setState({
        downPos: {
          x: pageX - this.state.pos.x,
          y: pageY - this.state.pos.y
        },
        edit: true
      });     
    }else if (cursor !== 'auto'){
      const x0 = this.state.pos.x;
      const y0 = this.state.pos.y
      const x1 = x0 + this.state.size.width;
      const y1 = y0 + this.state.size.height;
      var anchorX = [];
      var anchorY = [];
      if (this.state.edgeIndex.x < 2){
        anchorX.push(x1);
      }
      if (this.state.edgeIndex.x > 0){
        anchorX.push(x0);
      }
      if (this.state.edgeIndex.y < 2){
        anchorY.push(y1);
      }
      if (this.state.edgeIndex.y > 0){
        anchorY.push(y0);
      }
      this.setState({
        anchorPoints: {x: anchorX, y: anchorY},
        edit: true
      })
    }
    if (!this.isTouch) e.preventDefault();
  }

  setValidate = validate => {
    this.setState({validate: validate});
    this.props.updateValidate(validate.size && validate.aspect);
  }

  setCropArea = () => {
    const cx = this.state.pos.x / this.props.imageSize.width;
    const cy = this.state.pos.y / this.props.imageSize.height;
    const cw = this.state.size.width / this.props.imageSize.width;
    const ch = this.state.size.height / this.props.imageSize.height;
    this.props.data.set('cropArea', {
      pos: {x: cx, y: cy},
      size: {width: cw, height: ch}
    });
  }

  render() {
    const {classes, theme} = this.props;
    const shadowSize = Math.max(this.props.imageSize.width, this.props.imageSize.height);
    const isValidate = this.state.validate.size && this.state.validate.aspect;
    const invalidShadow = ', inset 0 0 ' + Math.min(this.state.size.width, this.state.size.height) + 'px rgba(256, 0, 0, 0.7)';
    const knotWidth = 10;
    const borderWidth = 2;
    const cornerOffset = (borderWidth + knotWidth)/2;
    const cornerWidth = this.state.size.width - borderWidth - cornerOffset;
    const cornerHeight = this.state.size.height - borderWidth - cornerOffset;
    const frameColor = isValidate ? theme.palette.primary.main : 'red';

    return (
      <div className={classes.overlay}
        ref={ elm => this.overlay = elm}
        style={{
          left: this.state.pos.x,
          top: this.state.pos.y - this.props.imageSize.height - 4, //謎之數字
          width: this.state.size.width,
          height: this.state.size.height,
          boxShadow: '0 0 0 ' + shadowSize + 'px rgba(0, 0, 0, 0.6)' + (isValidate ? '' : invalidShadow),
          border: borderWidth + 'px solid ' + frameColor,
        }}
      >
        <Knot width={knotWidth} color={frameColor} style={{position: 'absolute', left: -cornerOffset, top: -cornerOffset}} />
        <Knot width={knotWidth} color={frameColor} style={{position: 'absolute', left: cornerWidth, top: -cornerOffset}} />
        <Knot width={knotWidth} color={frameColor} style={{position: 'absolute', left: -cornerOffset, top: cornerHeight}} />
        <Knot width={knotWidth} color={frameColor} style={{position: 'absolute', left: cornerWidth, top: cornerHeight}} />
        <CropCanvas resizeLength={this.props.data.resizeLength} size={this.state.size} setValidate={this.setValidate}/>
      </div>
    );
  }
}

export default withTheme()(withData(withStyles(styles)(CropOverlay)));


// WEBPACK FOOTER //
// ./src/components/CropOverlay.js